import React from 'react';
import { Button, Cell, DataTable, Grid, TableBody, TableColumn, TableHeader, TableRow } from 'react-md';
import '../css/settings.css';
import LoadingSpinner from './LoadingSpinner';

const ServiceStatusTable = (props) => (
    
                <Grid key="SemesterTable">
                    <Cell size={12} className="semester-title">
                        <h3>Activity Status</h3>
                        <Button icon tooltipLabel="Refresh Table" style={{top:'5px'}} onClick={props.onRefresh}>refresh</Button>
                    </Cell>
                   
                    <Cell size={12}  className="semester-table-container">
                        {props.statusList && !props.loading?
                            <StatusDataTable {...props} />
                            :
                            <LoadingSpinner/>  
                        } 
                    </Cell>
                </Grid>
   
);

const ErrorMap =["Not Started","In Progress","Success","Fail","Timeout"]
const StatusDataTable = (props) => {
    
    return <DataTable plain >
                <TableHeader>
                <TableRow>
                    <TableColumn>ID</TableColumn>
                    <TableColumn>Event</TableColumn>
                    <TableColumn>Status</TableColumn>
                    {/* <TableColumn>Details</TableColumn> */}
                    <TableColumn>Created Time</TableColumn>
                    <TableColumn>Completion Time</TableColumn>
                </TableRow>
                </TableHeader>
                <TableBody>
                {props.statusList.map((status, _) => (
                    <TableRow key={status.id}>
                        <TableColumn>{status.id}</TableColumn>
                        <TableColumn>{status.eventType}</TableColumn>
                        <TableColumn>{ErrorMap[status.status]}</TableColumn>
                        <TableColumn>{status.createdDate}</TableColumn>
                        <TableColumn>{status.lastUpdated}</TableColumn>
                    </TableRow>
                ))}
                </TableBody>
            </DataTable>
}

export default ServiceStatusTable;